<template>
	<div style="height: 100%;">
		<div class="contL">
			<div class="contMenu">
				<ul>
					<li :class="{menuList_cur:index===selectIndex}" @click="changeCur(index,item)" class="menuList" v-for="(item,index) in this.deviceData">{{item.name}}</li>
				</ul>
			</div>
		</div>
		<div class="contR">
			<div class="cont"  >
				<div class="oneDevice" v-for="(item,index) in deviceList" @click="linkTo(item)">
					<div class="deviceTit">
						<div>
							<span>{{item.deviceName}}</span><span></span>
						</div>
						<div class="type_normal" :style="item.abnormal!='0'?type_normal:type_unnormal"></div>
					</div>
					<div class="deviceCont">
						<div>IP地址:</div><div>{{item.deviceIp}}</div>
					</div>
					<div class="deviceCont">
						<div>正常/非正常:</div><div>{{item.normal}}/{{item.abnormal}}</div>
					</div>
					<div class="deviceCont">
						<div>设备型号:</div><div>{{item.deviceModel}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	export default{
		name:'WcTabMonitor',
		props:['deviceData','number'],
		data(){
			return{
				selectIndex:0,
				type_normal:{
					background:'#F9040B'
				},
				type_unnormal:{
					background:'#00FF01'
				},
				deviceList:[]
			}
		},
		methods:{
			addCur(){
				//var firstList = document.getElementsByClassName("menuList")[0];
				//firstList.classList.add("menuList_cur");
			},
			changeCur(index,item){
				this.selectIndex = index;
				if(this.number==0){
					this.getDeviceInfoByType(item.id);
				}else{
					this.getGroupInfoByType(item);
				}
				
			},
			getDeviceInfoByType(id){
				if(!id){return}
				_api('_monitor','.code',{params:{mark:'deviceInfoByMonitorType',monitorType:id}},res=>{
					this.deviceList=res.data;
				},err=>{
					
				})
			},
			getGroupInfoByType(item){
				if(!item.id){return}
				_api('_monitor','.code',{params:{mark:'deviceInfoByGroupId',groupId:item.id,subGroupId:item.subGroupId}},res=>{
					console.error(2222,res)
					//this.deviceList=res.data;
					this.deviceList=res.data;
				},err=>{
					
				})
			},
			linkTo(item){
				this.$router.push('/MonitorDetail?type='+item.monitorType+'&ip='+item.deviceIp+'&resource='+item.resource+"&s="+(parseInt(this.number)+1)+"&i="+this.selectIndex);
			}
		},
		mounted:function(){
			//this.addCur();
			/*this.$nextTick(()=>{
				this.setActive();
			})*/
		}
		
	}
</script>

<style scoped="scoped">
	.contL{
		width: 25%;
		height: 100%;
		padding-top: 10px;
		box-sizing: border-box;
		display: inline-block;
		float: left;
	}
	.contMenu{
		width: 100%;
		height: 100%;
		background: #E6E6E6;
		border-top: 1px solid #E6E6E6;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}
	.contR{
		width: 75%;
		height: 100%;
		padding:10px 5px 0 10px;
		box-sizing: border-box;
		display: inline-block;
		float: left;
		overflow: auto;
	}
	.cont{
		width: 100%;
		height: 100%;
	}
	.list_show{
		display: block;
	}
	.menuList{
		height: 40px;
		line-height: 40px;
		border-left: 2px solid #E6E6E6;
		color: #4A4A4A;
		font-size: 14px;
		padding-left: 10px;
	}
	.menuList_cur{
		border-left: 2px solid #03A6C9;
		color: #03A6C9;
		background: #F3F3F3;
	}
	.oneDevice{
		background: #FFFFFF;
		box-shadow: 2px 2px 10px #DDDDDD;
		padding: 0 15px;
		margin-bottom: 10px;
	}
	.deviceTit{
		height: 30px;
		border-bottom: 1px solid #EEEEEE;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #383838;
	}
	.deviceCont{
		height: 35px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #7F7F7F;
	}
	.type_normal{
		width: 12px;
		height: 12px;
		background: red;
		border-radius: 12px;
		box-shadow: 2px 2px 8px #6D6C68;
	}
	.type_unnormal{
		background: #00FF01;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/monitor/tabMonitor/WcTabMonitor.vue